// Values are substituted at bundle-deploy time from `redoPartnersApp()`
// in `redo/partners/infra/src/index.ts`. Reads here use string-literal
// `process.env.X` lookups so the substituter can rewrite them — do NOT
// pull these into a wrapper that reads `process.env` indirectly, or
// substitution stops working.

export const DATADOG_APPLICATION_ID = process.env.DATADOG_APPLICATION_ID || "";

export const DATADOG_CLIENT_TOKEN = process.env.DATADOG_CLIENT_TOKEN || "";

export const REDO_PARTNERS_APP_VERSION =
  process.env.REDO_PARTNERS_APP_VERSION || "_";

export const REDO_PARTNERS_SERVER_URL =
  process.env.REDO_PARTNERS_SERVER_URL || "http://localhost:8045";
